import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom'

import PrimaryButton from './PrimaryButton'

const StyledMenuButton = styled.div`
  display: flex;
  align-items: right;
  font-size: 1.1rem;
  color: #FFF;
  line-height: 64.5px;
  font-weight: bold;
  white-space: nowrap;
  margin-left: 2rem;
  min-width: 100px;
  justify-content: center;
  align-content: center;
  
  :first-of-type {
    margin-left: 0;
  } 
  
@media (max-width: 800px) {
  line-height: 44px;
  font-size: 1.4rem;
  margin-left: 0;
}
`;

const SendCoinsButton = styled(PrimaryButton)`
  background-color: transparent;
  border: 1px solid #FFF;
  padding: 0 22px;
  box-shadow: none;
  cursor: pointer;
`;

const MenuButton = (props) => (
  <StyledMenuButton>
    {
      props.primary ?
        <SendCoinsButton to={props.to} {...props}>{props.children}</SendCoinsButton>
        :
        (props.href ?
          <a href={props.href} {...props}>
            {props.children}
          </a>
          :
          <Link to={props.to}>
            {props.children}
          </Link>)
    }
  </StyledMenuButton>);


export default MenuButton;


// WEBPACK FOOTER //
// ./src/Components/MenuButton.js